export default "__VITE_ASSET__CCR8zIhz__"